import { format } from "date-fns";

export const COLUMNS = [
  {
    Header: "Employee Id",
    accessor: "EmployeeId",
    id: "EmployeeId"
  },
  {
    Header: "Employee FirstName",
    accessor: "EmployeeFirstName",
    id: "EmployeeFirstName"
  },
  {
    Header: "Employee LastName",
    accessor: "EmployeeLastName",
    id: "EmployeeLastName"
  },
  {
    Header: "Employee Type",
    accessor: "EmployeeType",
    id: "EmployeeType"
  },
  {
    Header: "Employee Status",
    accessor: "EmployeeStatus",
    id: "EmployeeStatus"
  },
  {
    Header: "Supervisor Name",
    accessor: "SupervisorName",
    id: "SupervisorName"
  },
  {
    Header: "Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Booking Code",
    accessor: "BookingCode",
    id: "BookingCode"
  },
  {
    Header: "Booking Description",
    accessor: "BookingCodeDescription",
    id: "BookingCodeDescription"
  },
  {
    Header: "Category",
    accessor: "BookingCodeCatgCodeDescription",
    id: "BookingCodeCatgCodeDescription"
  },
  {
    Header: "Comment",
    accessor: "Comment",
    id: "Comment"
  },
  {
    Header: "Created Date",
    accessor: "CreatedDateTime",
    id: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy HH:mm") : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy",
    id: "CreatedBy"
  }
];
